import { BarChart, Bar, Cell, ResponsiveContainer } from 'recharts';
import { s } from './ResultReport.styles';

interface Props {
  chartData: {
    name: string;
    value: number;
    displayValue?: number;
    color: string;
  }[];
}

function BarChartGraph({ chartData }: Props) {
  // function BarChartGraph({ appraisalRate, auctionRate, transactionRate }: Props) {

  return (
    <s.GraphContainer>
      <s.GraphWrapper>
        <ResponsiveContainer width="100%" height={156}>
          <BarChart data={chartData}>
            <Bar dataKey="value" radius={[8, 8, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </s.GraphWrapper>

      <s.DataColumn>
        {chartData.map((item) => (
          <s.DataItem key={item.name}>
            <s.LegendColor $bg={item.color} />
            <s.ItemContent>
              <s.ItemLabel>{item.name}</s.ItemLabel>
              <s.ItemValue>
                {item.displayValue ? item.displayValue : item.value}%
              </s.ItemValue>
            </s.ItemContent>
          </s.DataItem>
        ))}
      </s.DataColumn>
    </s.GraphContainer>
  );
}

export default BarChartGraph;
